import {v1 as uuidv1} from "uuid";
import {router} from "../main";
import url from "@/rest/url";

const searchByMaxStklId = {
    methods: {
        searchByMaxStklId(maxStklId) {
            this.$store.commit('setKonfigModel', {})
            let loadingFlag = uuidv1();
            this.$store.commit('setLoadingFlag', loadingFlag);
            //get usermode standard or expert
            let userData = this.$store.getters.getUserData;
            let isStandardMode = true;
            if(userData.defaultModus === undefined){
                isStandardMode = true
            } else if (userData.defaultModus.includes('STANDARD')) {
                isStandardMode = true
            } else if(userData.defaultModus.includes('EXPERT')) {
                isStandardMode = false
            }

            if(isStandardMode) {
                this.$store.dispatch('initModelByMaxStklId', {
                    maxStklId: maxStklId
                }).then( (response) => {
                        if(response.errors.length > 0){
                            this.$notify({
                                type: 'error', duration: 3000,
                                text: this.$t(response.errors[0])
                            });
                        } else {
                            router.push({
                                name: 'ConfigPageByMaxStklId',
                                params: {
                                    maxStklId: maxStklId,
                                }
                            })
                        }
                    }
                ).finally( () => {
                        this.$store.commit('removeLoadingFlag', loadingFlag);
                    }
                )
            } else {
                //expertenkonfiguration
                try {
                    window.location.href = url.apiLocation + '/expert/model/' + maxStklId;
                } catch (e) {
                    console.log(e)
                    this.$notify({
                        type: 'error', duration: 3000,
                        text: this.$t('error-messages.configureNotPossible')
                    });
                } finally {
                    this.$store.commit('removeLoadingFlag', loadingFlag);
                }
            }

        },
    }
};

export default searchByMaxStklId;